import React, {Component} from 'react';
import {Trans} from '@lingui/macro';
import {extractTranslatedLabel} from '../../services/utilities';
import TestItemIcon from '../TestItemIcon';
import CloseIcon from '../Icons/CloseIcon';
import FlatButton from '../FlatButton';
import Cover from '../Cover';

//import cl from 'classnames';
import s from './TestDetails.css';
import config from 'config';

function getCover({id, src, color}) {
  return <Cover id={id} src={src} color={color || '#E25240'} />;
}

const letterStyle = {
  fontSize: '30px',
};

class TestDetails extends Component {
  startTest = () => {
    this.props.startTest();
  };

  render() {
    const {currentTest, lang, isMobile, goBack} = this.props;
    const name = extractTranslatedLabel(currentTest, lang, 'name');
    const cover = currentTest.getIn(['jsonData', 'image']);
    const coverUrl = cover && `${config.testBaseUrl}images/${cover}`;

    if (isMobile) {
      return (
        <div className={s.TestDetails}>
          <div className={s.Container}>
            {getCover({
              id: currentTest.get('id'),
              src: coverUrl,
              color: currentTest.getIn(['jsonData', 'color'], '#E25240'),
            })}
            <div className={s.CloseContainer}>
              <FlatButton onClick={goBack} className={s.Close}>
                <CloseIcon width={'1.2em'} height={'1.2em'} customColor />
              </FlatButton>
            </div>
            <div className={s.AvatarAndText}>
              <TestItemIcon
                letterStyle={letterStyle}
                className={s.ItemAvatarMobile}
                iconLabel={currentTest.get('abbreviation') || name.substr(0, 2).toUpperCase()}
                size={80}
                isActive={true}
              />
              <h2>{name}</h2>
            </div>
            <div className={s.Divider} />
            <p>{extractTranslatedLabel(currentTest, lang, 'description')}</p>
          </div>

          <div className={s.FooterButton}>
            <FlatButton className={s.StartButton} onClick={this.startTest}>
              <Trans id="test_details.label_btn_inizia">Inizia</Trans>
            </FlatButton>
          </div>
        </div>
      );
    }

    return (
      <div className={s.TestDetails}>
        <div className={s.Container}>
          {getCover({
            id: currentTest.get('id'),
            src: coverUrl,
            color: currentTest.getIn(['jsonData', 'color'], '#E25240'),
          })}
          <TestItemIcon
            letterStyle={letterStyle}
            className={s.ItemAvatar}
            iconLabel={currentTest.get('abbreviation') || name.substr(0, 2).toUpperCase()}
            size={100}
            isActive={true}
          />
        </div>

        <div className={s.FooterButton}>
          <FlatButton className={s.StartButton} onClick={this.startTest}>
            <Trans id="test_details.label_btn_inizia">Inizia</Trans>
          </FlatButton>
        </div>
      </div>
    );
  }
}

export default TestDetails;
